// NeSL "N" monogram for the Documents > Quick Access > NeSL Errors sidebar entry.
// Lightweight placeholder matching the sidebar's 24px stroke-icon convention
// (inherits colour via currentColor).
import React from 'react';

const NeslMonogramIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="3"
      y="3"
      width="18"
      height="18"
      rx="4"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M9 16V8L15 16V8"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NeslMonogramIcon;
